export default "__VITE_ASSET__COcoDLP___"